import React from "react";
import { api } from "@/lib/api";
import { formatIDR, formatDate } from "@/lib/format";

export default function PaymentsPage() {
  const [rows, setRows] = React.useState([]);
  React.useEffect(() => { (async () => { const { data } = await api.get("/payments"); setRows(data); })(); }, []);
  return (
    <div className="space-y-4" data-testid="payments-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "Manrope, sans-serif" }}>Pembayaran</h1>
        <p className="text-sm text-neutral-500">Semua pembayaran yang tercatat.</p>
      </div>
      <div className="card-flat overflow-x-auto">
        <table className="w-full data-table">
          <thead><tr>
            <th className="text-left">Kuitansi</th>
            <th className="text-left">Tanggal</th>
            <th className="text-left">Metode</th>
            <th className="text-left">Referensi</th>
            <th className="text-left">Dicatat oleh</th>
            <th className="text-right">Jumlah</th>
          </tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} data-testid={`payment-row-${p.id}`}>
                <td className="font-mono text-xs">{p.receipt_number}</td>
                <td className="text-xs">{formatDate(p.date)}</td>
                <td className="text-xs capitalize">{p.method}</td>
                <td className="text-xs">{p.reference || "-"}</td>
                <td className="text-xs">{p.recorded_by_name}</td>
                <td className="text-right font-medium text-green-700">{formatIDR(p.amount)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-sm text-neutral-500">Belum ada pembayaran.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
